// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-jsx": () => import("./../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-ts-evolution-jsx": () => import("./../src/pages/ts-evolution.jsx" /* webpackChunkName: "component---src-pages-ts-evolution-jsx" */),
  "component---src-pages-weekly-jsx": () => import("./../src/pages/weekly.jsx" /* webpackChunkName: "component---src-pages-weekly-jsx" */),
  "component---src-templates-post-jsx": () => import("./../src/templates/post.jsx" /* webpackChunkName: "component---src-templates-post-jsx" */),
  "component---src-templates-tags-jsx": () => import("./../src/templates/tags.jsx" /* webpackChunkName: "component---src-templates-tags-jsx" */)
}

